export const dateRangePickerIntlIds = {
  selectPeriodOrDateInput: {
    placeholder: 'dateRangePickerIntlIds.selectPeriodOrDateInput.placeholder',
  },
  goBackToTodayButton: {
    label: 'dateRangePickerIntlIds.goBackToTodayButton.label',
  },
  clearSelectedPeriodButton: {
    label: 'dateRangePickerIntlIds.clearSelectedPeriodButton.label',
  },
  cancelButton: {
    label: 'dateRangePickerIntlIds.cancelButton.label',
  },
  selectPeriodButton: {
    label: 'dateRangePickerIntlIds.selectPeriodButton.label',
  },
  previousMonthAria: {
    label: 'dateRangePickerIntlIds.previousMonthAria.label',
  },
  nextMonthAria: {
    label: 'dateRangePickerIntlIds.nextMonthAria.label',
  },
};
